import { render, staticRenderFns } from "./edit-sme-kyc.vue?vue&type=template&id=38296b0d&scoped=true&"
import script from "./edit-sme-kyc.vue?vue&type=script&lang=js&"
export * from "./edit-sme-kyc.vue?vue&type=script&lang=js&"
import style0 from "./edit-sme-kyc.vue?vue&type=style&index=0&id=38296b0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38296b0d",
  null
  
)

export default component.exports